<template>
  <section class="pb-16">
    <h3 class="sr-only">Løsningsforslag</h3>
    <UMathTaskAssignments show-suggestions />
  </section>
</template>
